import COLORS from 'pared/constants/colors'

import { IConfigsType } from '../../types'

const wingitnorthFinancialChart: IConfigsType = {
  wingitnorth: {
    '/:brand/sales_chart': {
      variables: [
        'date',
        'farwestTimeinterval',
        {
          type: 'selectOptions',
          options: {
            orderMode: {
              defaultId: [['net_sales']],
              options: [
                { id: 'net_sales', displayName: 'Total' },
                {
                  id: 'revenue_center_sales_call_dinein',
                  displayName: 'Call Dine In',
                },
                {
                  id: 'revenue_center_sales_call_togo',
                  displayName: 'Call To Go',
                },
                {
                  id: 'revenue_center_sales_dd_delivery',
                  displayName: 'DD Delivery',
                },
                {
                  id: 'revenue_center_sales_delivery',
                  displayName: 'Delivery',
                },
                {
                  id: 'revenue_center_sales_dispatch',
                  displayName: 'Dispatch',
                },
                {
                  id: 'revenue_center_sales_grub_hub',
                  displayName: 'Grub Hub',
                },
                { id: 'revenue_center_sales_online', displayName: 'Online' },
                {
                  id: 'revenue_center_sales_online_to_go',
                  displayName: 'Online To Go',
                },
                {
                  id: 'revenue_center_sales_uber_eats',
                  displayName: 'Uber Eats',
                },
                {
                  id: 'revenue_center_sales_walk_dine_in',
                  displayName: 'Walk Dine In',
                },
                {
                  id: 'revenue_center_sales_walk_togo',
                  displayName: 'Walk To Go',
                },
              ],
            },
          },
        },
      ],
      groupFilter: {
        api: 'corporateWithoutBreakdownAndLocationFilter',
      },
      dateFilter: {
        types: ['year'],
        defaultType: 'year',
      },
      pageTitle: {
        type: 'title',
        title: 'Total Sales Charts',
      },
      salesChartFilters: {
        type: 'grid',
        children: {
          downloadReport: {
            type: 'download-csv',
            api: 'wingitnorthSalesCharts',
            fileName: 'getexpo-wingitnorth-sales-charts',
            message: 'Download as CSV',
            fields: [
              {
                key: 'period',
                title: 'Date Period - Metric',
              },
              {
                key: 'currentValue',
                title: 'Data for <%- date?.getInfo(0)?.displayName %>',
              },
              {
                key: 'lastYearValue',
                title:
                  'Data for <%- (parseInt(date?.getInfo(0)?.displayName) - 1).toString() %>',
              },
            ],
          },
          timeColumns: {
            type: 'select',
            value: 'farwestTimeinterval.value',
            onChange: 'farwestTimeinterval.onChange',
            options: 'farwestTimeinterval.options',
            label: 'Time Interval:',
          },
          revenueColumns: {
            type: 'select',
            value: 'selectOptions.orderMode.value',
            onChange: 'selectOptions.orderMode.onChange',
            options: 'selectOptions.orderMode.options',
            label: 'Channel:',
          },
        },
      },
      salesChart: {
        type: 'bar-chart',
        api: 'winSales',
        width: 1500,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'value',
            label: 'Current Year Sales',
            borderColor: COLORS.Basil,
            backgroundColor: COLORS.Basil,
          },
          {
            key: 'valueLastYear',
            label: 'Prior Year Sales',
            borderColor: COLORS.Plum,
            backgroundColor: COLORS.Plum,
          },
        ],
        scaleTypes: {
          y: {
            type: 'price',
            beginAtZero: true,
          },
        },
        options: {
          scales: {
            x: {
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
          },
        },
      },
    },
    '/:brand/sss_chart': {
      variables: [
        'date',
        'farwestTimeinterval',
        {
          type: 'selectOptions',
          options: {
            orderMode: {
              defaultId: [['net_sales']],
              options: [
                { id: 'net_sales', displayName: 'SSS%' },
                { id: 'check_count', displayName: 'SST%' },
                {
                  id: 'check_average',
                  displayName: 'SSC%',
                },
              ],
            },
          },
        },
      ],
      groupFilter: {
        api: 'corporateWithoutBreakdownAndLocationFilter',
      },
      dateFilter: {
        types: ['year'],
        defaultType: 'year',
      },
      pageTitle: {
        type: 'title',
        title: 'SSS/SST/SSC Charts',
      },
      salesChartFilters: {
        type: 'grid',
        children: {
          downloadReport: {
            type: 'download-csv',
            api: 'wingitnorthSssCharts',
            fileName: 'getexpo-wingitnorth-sss-sst-ssc-charts',
            message: 'Download as CSV',
            fields: [
              {
                key: 'period',
                title: 'Date Period - Metric',
              },
              {
                key: 'currentValue',
                title: '1Y Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'twoYearsStackedValue',
                title: '2Y Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'lastYearValue',
                title:
                  '1Y Data for <%- (parseInt(date?.getInfo(0)?.displayName) - 1).toString() %>',
                decimal: 4,
              },
            ],
          },
          timeColumns: {
            type: 'select',
            value: 'farwestTimeinterval.value',
            onChange: 'farwestTimeinterval.onChange',
            options: 'farwestTimeinterval.options',
            label: 'Time Interval:',
          },
          revenueColumns: {
            type: 'select',
            value: 'selectOptions.orderMode.value',
            onChange: 'selectOptions.orderMode.onChange',
            options: 'selectOptions.orderMode.options',
            label: 'Channel:',
          },
        },
      },
      sssChart: {
        type: 'bar-chart',
        api: 'winSss',
        width: 1500,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'value',
            label: '1 Year',
            borderColor: COLORS.Basil,
            backgroundColor: COLORS.Basil,
          },
          {
            chartType: 'line',
            key: 'valueTwoYearsStacked',
            label: '2 Years',
            borderColor: COLORS.ExpoRed1,
            backgroundColor: COLORS.ExpoRed1,
          },
          {
            key: 'valueLastYear',
            label: 'Prior Year',
            borderColor: COLORS.Plum,
            backgroundColor: COLORS.Plum,
          },
        ],
        scaleTypes: {
          y: {
            type: 'percent',
            beginAtZero: true,
          },
        },
        options: {
          scales: {
            x: {
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
          },
        },
      },
    },
    '/:brand/check_average_chart': {
      variables: [
        'date',
        'farwestTimeinterval',
        {
          type: 'selectOptions',
          options: {
            orderMode: {
              defaultId: [['check_average']],
              options: [
                { id: 'check_average', displayName: 'Total' },
                {
                  id: 'revenue_center_check_average_call_dinein',
                  displayName: 'Call Dine In',
                },
                {
                  id: 'revenue_center_check_average_call_togo',
                  displayName: 'Call To Go',
                },
                {
                  id: 'revenue_center_check_average_dd_delivery',
                  displayName: 'DD Delivery',
                },
                {
                  id: 'revenue_center_check_average_delivery',
                  displayName: 'Delivery',
                },
                {
                  id: 'revenue_center_check_average_dispatch',
                  displayName: 'Dispatch',
                },
                {
                  id: 'revenue_center_check_average_grub_hub',
                  displayName: 'Grub Hub',
                },
                {
                  id: 'revenue_center_check_average_online',
                  displayName: 'Online',
                },
                {
                  id: 'revenue_center_check_average_online_to_go',
                  displayName: 'Online To Go',
                },
                {
                  id: 'revenue_center_check_average_uber_eats',
                  displayName: 'Uber Eats',
                },
                {
                  id: 'revenue_center_check_average_walk_dine_in',
                  displayName: 'Walk Dine In',
                },
                {
                  id: 'revenue_center_check_average_walk_togo',
                  displayName: 'Walk To Go',
                },
              ],
            },
          },
        },
      ],
      groupFilter: {
        api: 'corporateWithoutBreakdownAndLocationFilter',
      },
      dateFilter: {
        types: ['year'],
        defaultType: 'year',
      },
      pageTitle: {
        type: 'title',
        title: 'Check Average Charts',
      },
      checkAverageChartFilters: {
        type: 'grid',
        children: {
          downloadReport: {
            type: 'download-csv',
            api: 'wingitnorthCheckAverageCharts',
            fileName: 'getexpo-wingitnorth-check-average-charts',
            message: 'Download as CSV',
            fields: [
              {
                key: 'period',
                title: 'Date Period - Metric',
              },
              {
                key: 'currentValue',
                title: 'Data for <%- date?.getInfo(0)?.displayName %>',
              },
              {
                key: 'lastYearValue',
                title:
                  'Data for <%- (parseInt(date?.getInfo(0)?.displayName) - 1).toString() %>',
              },
            ],
          },
          timeColumns: {
            type: 'select',
            value: 'farwestTimeinterval.value',
            onChange: 'farwestTimeinterval.onChange',
            options: 'farwestTimeinterval.options',
            label: 'Time Interval:',
          },
          revenueColumns: {
            type: 'select',
            value: 'selectOptions.orderMode.value',
            onChange: 'selectOptions.orderMode.onChange',
            options: 'selectOptions.orderMode.options',
            label: 'Channel:',
          },
        },
      },
      checkAverageChart: {
        type: 'bar-chart',
        api: 'winCheckAverage',
        width: 1500,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'value',
            label: 'Current Year Check Average',
            decimal: 2,
            borderColor: COLORS.Basil,
            backgroundColor: COLORS.Basil,
          },
          {
            key: 'valueLastYear',
            label: 'Prior Year Check Average',
            decimal: 2,
            borderColor: COLORS.Plum,
            backgroundColor: COLORS.Plum,
          },
        ],
        scaleTypes: {
          y: {
            type: 'price',
            decimal: 2,
            min: 1500,
          },
        },
        options: {
          scales: {
            x: {
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
          },
        },
      },
    },
  },
}

export default wingitnorthFinancialChart
